import { ChestSvg } from '../atoms/ChestSvg';

/**
 * Renders treasure chests scrolling with the terrain.
 * Props: chests (array from s.chests)
 */
export function ChestLayer({ chests }) {
  if (!chests?.length) return null;

  return chests.map(chest => (
    <div
      key={chest.id}
      className="chest"
      style={{ transform: `translate3d(${chest.x}px,${chest.y}px,0)`, width: chest.size, height: chest.size }}
    >
      <ChestSvg size={chest.size} />
    </div>
  ));
}
